import { InputLabel, Select, TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import useColors from "../../../api/hooks/useColors";

export const StyledTextField = styled(TextField)(({ theme }) => {
  const colors = useColors();

  return {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: colors.textfield_border, // Regular state
      borderRadius: 8,
    },
    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: colors.textfield_border_hover, // Hover state
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: colors.textfield_border_focus, // Focus state
    },
    "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
      borderColor: colors.error_500, // Error state
      borderWidth: "1px",
    },
    "& .MuiOutlinedInput-input": {
      fontSize: theme.typography.caption.fontSize,
      fontFamily: theme.typography.caption.fontFamily,
      lineHeight: theme.typography.caption.lineHeight,
      letterSpacing: theme.typography.caption.letterSpacing,
    },
    "& .MuiInputLabel-root": {
      color: colors.text_secondary,
      "&.Mui-error": {
        color: colors.text_secondary, // Keep the same color even in error state
      },
      "&.MuiInputLabel-shrink": {
        fontSize: "0.875rem", // Larger font when shrunk/on top (14px)
        transform: "translate(14px, -9px) scale(1)",
      },
      fontSize: "0.75rem", // Regular size when inside (12px)
      "& .MuiInputLabel-asterisk": {
        color: colors.error_500, // Make the asterisk red
      },
    },
    "& .MuiFormHelperText-root": {
      "&.Mui-error": {
        color: colors.error_500, // Error message color
      },
    },
  };
});

export const StyledSelect = styled(Select)(({ theme }) => {
  const colors = useColors();

  return {
    "& .MuiOutlinedInput-notchedOutline": {
      border: "1px solid " + colors.textfield_border, // Regular state
      borderRadius: 8,
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      border: "1px solid " + colors.textfield_border_hover, // Hover state
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: "1px solid " + colors.textfield_border_focus, // Focus state
    },
    "&.Mui-error .MuiOutlinedInput-notchedOutline": {
      border: "1px solid " + colors.error_500, // Error state
    },
    "& .MuiOutlinedInput-input": {
      fontSize: theme.typography.caption.fontSize,
      fontFamily: theme.typography.caption.fontFamily,
      lineHeight: theme.typography.caption.lineHeight,
      letterSpacing: theme.typography.caption.letterSpacing,
    },
  };
});

export const StyledInputLabel = styled(InputLabel)(({ theme }) => {
  const colors = useColors();

  return {
    color: colors.text_secondary,
    "&.Mui-error": {
      color: colors.text_secondary, // Keep the same color even in error state
    },
    "&.MuiInputLabel-shrink": {
      fontSize: "0.875rem", // Larger font when shrunk/on top (14px)
      transform: "translate(14px, -9px) scale(1)",
    },
    fontSize: "0.75rem", // Regular size when inside (12px)
    "&.MuiInputLabel-root": {
      backgroundColor: theme.palette.background.paper,
      padding: "0 4px",
    },
  };
});

export const getTextFieldInputProps = (params = {}) => ({
  ...params,
  sx: {
    ...params?.sx,
  },
});

export const textFieldLabelProps = (params = {}) => ({
  ...params,
  sx: {
    ...params?.sx,
  },
});
